const NONE = 'none'
const SOLID = 'solid'
const LINEAR = 'linear'

export { NONE, SOLID, LINEAR }
